import React from "react";
import { Modal } from "@toddle-edu/ds-web";
import _ from "lodash";

import { useI18n } from "Hooks";
import classes from "./ViewChannelTab.scss";
import {
  CHAT_TYPE_ENUM,
  getFormattedNameForUserType,
} from "MessagingV2/modules/Utils";
import { formatDate } from "Utils/DateTimeHelpers";
import classNames from "classnames";

const styles = {
  modalBodyStyles: {
    padding: "0px",
    overflow: "hidden",
  },
};

const ViewChannelTab = ({
  channelDescription,
  createdBy,
  createdAt,
  channelBannerMessage,
  channelLabel,
  channelType,
}) => {
  const { t } = useI18n(["common"]);

  const formattedDate = formatDate({
    date: createdAt,
    format: "MMMM D, YYYY",
  });

  const creatorName = getFormattedNameForUserType({
    user: createdBy,
  });

  const isChannelDescriptionEmpty = _.isEmpty(channelDescription);

  const isDepartmentChannel = _.isEqual(
    channelType,
    CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT
  );

  const firstHeaderTitle = isDepartmentChannel
    ? `${t("common:channel_name")}*`
    : t("common:description");

  const firstHeaderData = isDepartmentChannel
    ? channelLabel
    : isChannelDescriptionEmpty
    ? t("common:no_description_added")
    : channelDescription;

  const secondHeaderTitle = isDepartmentChannel
    ? t("common:banner_message")
    : t("common:created_by");

  const secondHeaderData = isDepartmentChannel
    ? channelBannerMessage
    : t("common:name_on_date", {
        name: creatorName,
        date: formattedDate,
      });

  return (
    <Modal.Body style={styles.modalBodyStyles}>
      <div className={classes.rootContainer}>
        <div className={classes.infoContainer}>
          <div className={"text-label"}>{firstHeaderTitle}</div>
          <div
            className={classNames("text-body", classes.infoDescription, {
              [classes.emptyDescription]: isChannelDescriptionEmpty,
            })}
          >
            {firstHeaderData}
          </div>
        </div>
        {!_.isEmpty(secondHeaderData) ? (
          <div className={classes.infoContainer}>
            <div className={"text-label"}>{secondHeaderTitle}</div>
            <div className={classNames("text-body", classes.infoDescription)}>
              {secondHeaderData}
            </div>
          </div>
        ) : null}
      </div>
    </Modal.Body>
  );
};

export default ViewChannelTab;
